import { ReactNode } from "react";
import { cx } from "../lib/classNames";

type Kind = "error" | "success" | "info";

const KIND_CLASSES: Record<Kind, string> = {
  error: "bg-red-950 border border-red-700 text-red-300",
  success: "bg-green-950 border border-green-700 text-green-300",
  info: "bg-slate-800 border border-slate-700 text-slate-300",
};

export interface BannerProps {
  readonly kind: Kind;
  readonly className?: string;
  readonly children: ReactNode;
}

export function Banner({ kind, className, children }: BannerProps) {
  return (
    <div
      role="alert"
      className={cx("rounded-md px-3 py-2.5 text-sm", KIND_CLASSES[kind], className)}
    >
      {children}
    </div>
  );
}
